module.exports = __webpack_public_path__ + "pic_bizny_web_02@1x.png?00d64160ef2136652d09c0bb5c2b7dbe";